(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || Shopify.money_format);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  function findPurchaseRoot(fromNode) {
    if (fromNode && fromNode.closest) {
      var nested = fromNode.closest('[data-product-purchase]');
      if (nested) return nested;
    }
    return document.querySelector('[data-product-purchase]');
  }

  function findPurchaseContext(fromNode) {
    var purchase = findPurchaseRoot(fromNode);
    if (!purchase) return null;

    var form = purchase.querySelector('form[data-type="add-to-cart-form"]');
    var variantInput = form ? form.querySelector('input[name="id"]') : null;
    var quantityWrap = purchase.querySelector('.compact-quantity');
    var priceEl = purchase.querySelector('[data-compact-price]');
    var buyBtn = purchase.querySelector('.compact-btn-buy-now');
    var actionsContainer = purchase.querySelector('.compact-actions-container');

    return {
      purchase: purchase,
      form: form,
      variantInput: variantInput,
      quantityWrap: quantityWrap,
      priceEl: priceEl,
      buyBtn: buyBtn,
      actionsContainer: actionsContainer,
    };
  }

  function syncMainVariantInput(variantId) {
    if (!variantId) return;
    document.querySelectorAll('product-info input[name="id"]').forEach(function (input) {
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function syncPackSelectionUI(root) {
    var ctx = findPurchaseContext(root);
    if (!ctx || !ctx.purchase) return;

    var hasSelection = !!(root && root.classList.contains('product-packs--has-selection'));
    var actionsContainer = ctx.actionsContainer;

    if (hasSelection) {
      ctx.purchase.classList.add('product-purchase--has-packs');
      if (ctx.quantityWrap) ctx.quantityWrap.classList.add('is-hidden-by-packs');
      if (actionsContainer) actionsContainer.classList.add('is-container-border-hidden-by-packs');
    } else {
      ctx.purchase.classList.remove('product-purchase--has-packs');
      if (ctx.quantityWrap) ctx.quantityWrap.classList.remove('is-hidden-by-packs');
      if (actionsContainer) actionsContainer.classList.remove('is-container-border-hidden-by-packs');
    }
  }

  function isCardDisabled(card) {
    return card.getAttribute('aria-disabled') === 'true' || card.classList.contains('is-sold-out');
  }

  function initPackSelector(root) {
    if (!root) return;

    if (root.dataset.initialized === 'true') {
      syncPackSelectionUI(root);
      return;
    }

    var ctx = findPurchaseContext(root);
    if (!ctx || !ctx.form) return;

    root.dataset.initialized = 'true';

    var moneyFormat = root.dataset.moneyFormat || '';
    var cards = root.querySelectorAll('.product-packs__card');

    function emitVariantChange(variantId, cleared) {
      document.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: {
            variantId: variantId,
            cleared: cleared,
            source: 'product-packs',
          },
        })
      );
    }

    function applyVariantToForm(variantId, priceFormatted, priceCents, available, cleared) {
      if (ctx.variantInput && variantId) {
        ctx.variantInput.value = variantId;
        ctx.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (ctx.buyBtn && variantId) {
        ctx.buyBtn.setAttribute('data-variant-id', variantId);
        ctx.buyBtn.disabled = available === 'false';
      }
      if (ctx.priceEl && priceFormatted) {
        ctx.priceEl.textContent = priceFormatted;
      }
      syncMainVariantInput(variantId);
      emitVariantChange(variantId, cleared);
      syncPackSelectionUI(root);
    }

    function clearSelection() {
      cards.forEach(function (card) {
        card.classList.remove('is-selected');
        card.setAttribute('aria-pressed', 'false');
      });
      root.classList.remove('product-packs--has-selection');
      root.blur();

      applyVariantToForm(
        root.dataset.defaultVariantId,
        root.dataset.defaultPriceFormatted,
        root.dataset.defaultPrice,
        root.dataset.defaultAvailable,
        true
      );
    }

    function setSelected(card) {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      root.classList.add('product-packs--has-selection');

      applyVariantToForm(
        card.dataset.variantId,
        card.dataset.priceFormatted,
        card.dataset.price,
        card.dataset.available,
        false
      );
    }

    function onCardActivate(card) {
      if (!card || isCardDisabled(card)) return;
      if (card.classList.contains('is-selected')) {
        clearSelection();
        return;
      }
      setSelected(card);
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        onCardActivate(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        onCardActivate(card);
      });
    });

    var preselected = root.querySelector('.product-packs__card.is-selected:not(.is-sold-out)');
    if (preselected && preselected.getAttribute('aria-disabled') !== 'true') {
      setSelected(preselected);
    } else {
      syncPackSelectionUI(root);
    }
  }

  function initAll(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;

    target.querySelectorAll('[data-product-packs-root]').forEach(function (root) {
      if (root.dataset.mountNearBuy === 'true') return;
      initPackSelector(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function () {
    syncPackSelectionUI(null);
  });

  document.addEventListener('product-sidebar:relocated', function () {
    if (
      document.documentElement.classList.contains('shopify-design-mode') ||
      (window.Shopify && window.Shopify.designMode)
    ) {
      return;
    }
    initAll(document);
  });
})();
